import {NgClass} from '@angular/common';
import {booleanAttribute, Component, Input} from '@angular/core';
import {KENDO_INDICATORS} from '@progress/kendo-angular-indicators';

//Composant attente opération
@Component (
{
  selector: 'val-attente-operation',
  imports: 
  [
    NgClass,
    KENDO_INDICATORS
  ],
  templateUrl: './attente-operation.component.html',
  styleUrl: './attente-operation.component.scss'
})
export class AttenteOperationComponent 
{
  //Création
  constructor () 
  {
    this.visible = false;
  }
  
  //Indique si visible
  @Input ({transform: booleanAttribute})
  public visible: boolean;
}
